import { render, staticRenderFns } from "./HomeForLeader.vue?vue&type=template&id=8edf5ec6&scoped=true&"
import script from "./HomeForLeader.vue?vue&type=script&lang=js&"
export * from "./HomeForLeader.vue?vue&type=script&lang=js&"
import style0 from "./HomeForLeader.vue?vue&type=style&index=0&id=8edf5ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edf5ec6",
  null
  
)

export default component.exports